import { selectCanEditOffer } from '../dataCollection/selectors';
import { RootState } from '../store';

export const canAccessAverageExpenditure = (state: RootState) =>
  selectCanEditOffer(state);
